import axios from 'axios';

const BASE_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';
const WORKFLOW_API_URL = `${BASE_API_URL}/QmsWorkflowTemplate`;

export interface WorkflowStep {
  id: string | number;
  stepNumber: number;
  stepName: string;
  stepType: 'single' | 'parallel' | 'conditional';
  approvers: any[];
  approvalRule: 'all' | 'any' | 'majority';
  timeLimit?: number;
  description: string;
  isOptional: boolean;
}

export interface WorkflowTemplate {
  id: string | number;
  templateName: string;
  documentType: string;
  description: string;
  steps?: WorkflowStep[];
  isActive: boolean;
}

export interface WorkflowResponse {
  message?: string;
  detail?: string;
}

/**
 * Get all workflow templates
 * Calls the GET /api/Workflow endpoint
 */
export const getAllTemplates = async (): Promise<WorkflowTemplate[]> => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get<WorkflowTemplate[]>(WORKFLOW_API_URL, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return response.data || [];
  } catch (error: any) {
    console.error('Failed to get all workflow templates:', error);
    throw new Error(
      error.response?.data?.message || 
      error.response?.data?.detail || 
      'Failed to get workflow templates'
    );
  }
};

/**
 * Get workflow template by ID
 * Calls the GET /api/Workflow/{id} endpoint
 */
export const getTemplateById = async (id: string | number): Promise<WorkflowTemplate> => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get<WorkflowTemplate>(`${WORKFLOW_API_URL}/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error(`Failed to get workflow template ${id}:`, error);
    throw new Error(
      error.response?.data?.message || 
      error.response?.data?.detail || 
      'Failed to get workflow template'
    );
  }
};

/**
 * Get workflow steps by template ID
 * Calls the GET /api/Workflow/{id}/steps endpoint
 */
export const getStepsByTemplateId = async (id: string | number): Promise<WorkflowStep[]> => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get<WorkflowStep[]>(`${WORKFLOW_API_URL}/${id}/steps`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return response.data || [];
  } catch (error: any) {
    console.error(`Failed to get workflow steps for template ${id}:`, error);
    throw new Error(
      error.response?.data?.message || 
      error.response?.data?.detail || 
      'Failed to get workflow steps'
    );
  }
};
